<template>
  <v-card>
    <!-- <v-card-title>User Login</v-card-title> -->
    <!-- {{newItem}} -->

    <!-- {{Object.keys(newItem).join()}} -->
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon large>add</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Add New Passenger</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text style="max-height: 85%">
      <v-form ref="addProjectForm" v-model="valid" lazy-validation>
      
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex md6 class="pr-1">
              <v-menu
                v-model="contractDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="newItem.contract_date"
                    label="Contract date *"
                    readonly
                    outline
                    required
                    :rules="requiredRules"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="newItem.contract_date"
                  @input="contractDateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs6>
            <v-autocomplete
                label="Select agent *"
                v-model="newItem.agent_id"
                :items="agentsTV"
                hide-details
                hide-selected
                item-text="text"
                item-value="value"
                outline
                required
                :rules="requiredRules"
              >
              </v-autocomplete>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12>
          <v-layout row wrap>
            <v-flex xs6>
              <v-autocomplete
                label="Applied Country *"
                v-model="newItem.applied_country"
                :items="COUNTRIES"
                hide-details
                hide-selected
                outline
                required
                :rules="requiredRules"
              >
              </v-autocomplete>
            </v-flex>
            <v-flex md6 pl-1>
              <v-text-field
                outline
                label="Profession *"
                v-model="newItem.profession"
                required
                :rules="requiredRules"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
      
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex md4>
              <v-text-field
                outline
                label="Candidate Name *"
                required
                v-model="newItem.name"
                :rules="requiredRules"
              ></v-text-field>
            </v-flex>
            <v-flex md4 pl-1>
              <v-text-field
                outline
                label="Father's Name *"
                required
                v-model="newItem.father_name"
                :rules="requiredRules"
              ></v-text-field>
            </v-flex>
            <v-flex md4 pl-1>
              <v-text-field
                outline
                label="Mother's Name *"
                required
                v-model="newItem.mother_name"
                :rules="requiredRules"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>

        
          <v-flex xs12> Present Address: </v-flex>
          <v-flex xs12>
            <v-layout>
              <v-flex md3>
                <v-autocomplete
                  label="District *"
                  v-model="newItem.present_district"
                  :items="districtTV()"
                  hide-details
                  hide-selected
                  item-text="text"
                  item-value="value"
                  outline
                  required
                  :rules="requiredRules"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex md3 pl-1>
                <v-autocomplete
                  label="PS *"
                  v-model="newItem.present_upazila"
                  :items="upazilaTV(newItem.present_district)"
                  hide-details
                  hide-selected
                  item-text="text"
                  item-value="value"
                  outline
                  required
                  :rules="requiredRules"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex md3 pl-1>
                <v-autocomplete
                  label="P.O *"
                  v-model="newItem.present_union"
                  :items="unionTV(newItem.present_upazila)"
                  hide-details
                  hide-selected
                  item-text="text"
                  item-value="value"
                  outline
                  required
                  :rules="requiredRules"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex md3 pl-1>
                <v-text-field
                  outline
                  label="Vill *"
                  required
                  v-model="newItem.present_village"
                  :rules="requiredRules"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12> Permanent Address: </v-flex>
          <v-flex xs12>
            <v-layout pb-1>
              <v-flex md3>
                <v-autocomplete
                  label="District"
                  v-model="newItem.permanent_district"
                  :items="districtTV()"
                  hide-details
                  hide-selected
                  item-text="text"
                  item-value="value"
                  outline
                >
                </v-autocomplete>
              </v-flex>
              <v-flex md3 pl-1>
                <v-autocomplete
                  label="PS"
                  v-model="newItem.permanent_upazila"
                  :items="upazilaTV(newItem.permanent_district)"
                  hide-details
                  hide-selected
                  item-text="text"
                  item-value="value"
                  outline
                >
                </v-autocomplete>
              </v-flex>
              <v-flex md3 pl-1>
                <v-autocomplete
                  label="P.O"
                  v-model="newItem.permanent_union"
                  :items="unionTV(newItem.permanent_upazila)"
                  hide-details
                  hide-selected
                  item-text="text"
                  item-value="value"
                  outline
                >
                </v-autocomplete>
              </v-flex>
              <v-flex md3 pl-1>
                <v-text-field
                  outline
                  label="Vill"
                  v-model="newItem.permanent_village"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12>
            <v-layout pb-1>
              <v-flex md4 pr-1>
                <v-text-field
                  outline
                  label="Passport number *"
                  required
                  v-model="newItem.passport_number"
                  :rules="requiredRules"
                ></v-text-field>
              </v-flex>
              <v-flex md4 pr-1>
                <v-menu
                  v-model="passportIssueDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="newItem.passport_issue_date"
                      label="Issue date *"
                      readonly
                      outline
                      required
                      :rules="requiredRules"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="newItem.passport_issue_date"
                    @input="passportIssueDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex md4>
                <v-menu
                  v-model="passportExpDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="newItem.passport_exp_date"
                      label="Exp date *"
                      readonly
                      outline
                      required
                      :rules="requiredRules"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="newItem.passport_exp_date"
                    @input="passportExpDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-flex>
          
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex md6 pr-1>
                <v-menu
                  v-model="dobDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="newItem.dob"
                      label="Date of birth *"
                      readonly
                      outline
                      v-on="on"
                      required
                      :rules="requiredRules"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="newItem.dob"
                    @input="dobDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6>
                <v-text-field 
                  outline label="Age *" v-model="newItem.age"
                  required
                  :rules="requiredRules"></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12>
            <v-layout row wrap>
              <v-flex md4 pr-1>
                <v-text-field
                  outline
                  label="NID Number *"
                  v-model="newItem.nid_number"
                  required
                  :rules="requiredRules"
                ></v-text-field>
              </v-flex>
              <v-flex md4 pr-1>
                <v-text-field
                  outline
                  label="Birth Cert. Number *"
                  v-model="newItem.birth_cert_number"
                  required
                  :rules="requiredRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-autocomplete
                  label="Nationality *"
                  v-model="newItem.nationality"
                  :items="NATIONALITIES"
                  hide-details
                  hide-selected
                  outline
                  required
                  :rules="requiredRules"
                >
                </v-autocomplete>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12>
            <v-layout row wrap pb-4>
              <v-flex md6 pr-1>
                <v-autocomplete
                  label="Gender *"
                  v-model="newItem.gender"
                  :items="GENDERS"
                  hide-details
                  hide-selected
                  outline
                  required
                  :rules="requiredRules"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  label="Religion *"
                  v-model="newItem.religion"
                  :items="getTV(RELIGIONS)"
                  hide-details
                  hide-selected
                  outline
                  required
                  :rules="requiredRules"
                >
                </v-autocomplete>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12>
            <v-layout row wrap pb-1>
              <v-flex md4 pr-1>
                <v-autocomplete
                  label="Marital Status"
                  v-model="newItem.marital_status"
                  :items="getTV(MARITAL_STATUSES)"
                  hide-details
                  hide-selected
                  outline
                >
                </v-autocomplete>
              </v-flex>
              <v-flex xs4 pr-1>
                <v-text-field
                  outline
                  label="Height"
                  v-model="newItem.height"
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  outline
                  label="Weight"
                  v-model="newItem.weight"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12>
            <v-layout row wrap pb-1>
              <v-flex md6 pr-1>
                <v-autocomplete
                  label="Expert in Language *"
                  v-model="newItem.language_proficiency"
                  :items="getTV(LANGUAGES, {textField:'name', valueField: 'name', isDeselect: false})"
                  hide-details
                  hide-selected
                  outline
                  multiple
                  required
                  :rules="requiredRules"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                    outline
                    label="Educational Qualification *"
                    v-model="newItem.educational_qualification"
                    required
                    :rules="requiredRules"
                  ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs6 pr-1>
                <v-text-field
                    outline
                    label="Work Exp *"
                    v-model="newItem.working_experience"
                    required
                    :rules="requiredRules"
                  ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                    outline
                    label="Type of Work Exp *"
                    v-model="newItem.working_experience_type"
                    required
                    :rules="requiredRules"
                  ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs6 pr-1>
                <v-text-field
                    outline
                    label="Mobile Number"
                    v-model="newItem.mobile"
                  ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                    outline
                    label="Family Mobile Number"
                    v-model="newItem.family_mobile_number"
                  ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-textarea v-model="newItem.notes" outline label="Notes"></v-textarea>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="onCancelled">Cancel</v-btn>
      <v-btn
        color="blue"
        @click="newItemDo"
        :disabled="!valid || actionButtonClicked"
        :loading="actionButtonClicked"
        >Add</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  GENDERS,
  MEDICAL_STATUSES,
  FINGER_STATUSES,
  VISA_TYPES,
  SERVICE_TYPES,
  PROJECT_OWNER,
  COUNTRIES,
  NATIONALITIES,
  RELIGIONS,
  MARITAL_STATUSES,
  LANGUAGES,
} from "../../mdsir/const";
import { getTV, removeEmptyProps, districtTV, upazilaTV, unionTV } from "../../mdsir/MdsirUtils";

const NEW_ITEM_DEFAULT = {
  contract_date: new Date().toISOString().substr(0, 10),
  agent_id: "", // old
  applied_country: "",
  profession: "",
  name: "", //old
  father_name: "",
  mother_name: "",
  present_district: "",
  present_upazila: "",
  present_union: "",
  present_village: "",
  permanent_district: "",
  permanent_upazila: "",
  permanent_union: "",
  permanent_village: "",
  passport_number: "", //old
  passport_issue_date: "",
  passport_exp_date: "",
  dob: "", //old
  age: "",
  nid_number: "", //old
  birth_cert_number: "",
  nationality: "",
  gender: "", //old
  religion: "",
  marital_status: "",
  height: "",
  weight: "",
  language_proficiency: [],
  educational_qualification: "",
  working_experience: "",
  working_experience_type: "",
  mobile: "", //old
  family_mobile_number: "",
  notes: "",

  // project_owner: "idm",
  // contract_date: new Date().toISOString().substr(0, 10),
  // // passport_number: "",
  // // name: "",
  // // mobile: "",
  // email: "",
  // notes: "",
  // address: "",
  // // gender: "male",
  // // dob: "",
  // // nid_number: "",
  // medical_date: "",
  // medical_status: "",
  // trade_name: "",
  // agent_id: "",
  // employer_id: "",
  // visa_issue_date: "",
  // flight_date: "",
  // visa_number: "",
  // visa_id_number: "",
  // service_type: "",
  // service_charge: "",
  // mofa_date: "",
  // mofa_number: "",
  // training_start_date: "",
  // training_end_date: "",
  // finger_status: "",
};

export default {
  props: ["agents", "employers"],
  data() {
    return {
      actionButtonClicked: false,
      valid: true,
      newItem: NEW_ITEM_DEFAULT,

      contractDateMenu: false,
      dobDateMenu: false,
      medicalDateMenu: false,
      mofaDateMenu: false,
      trainingStartDateMenu: false,
      trainingEndDateMenu: false,
      visaIssueDateMenu: false,
      flightDateMenu: false,
      COUNTRIES: COUNTRIES,
      NATIONALITIES: NATIONALITIES,
      RELIGIONS: RELIGIONS,
      MARITAL_STATUSES: MARITAL_STATUSES,
      LANGUAGES: LANGUAGES,
      passportIssueDateMenu: false,
      passportExpDateMenu: false,
    };
  },
  computed: {
    medicalStatuses() {
      return getTV(MEDICAL_STATUSES);
    },
    fingerStatuses() {
      return getTV(FINGER_STATUSES);
    },
    visaTypes() {
      return getTV(VISA_TYPES);
    },
    serviceTypes() {
      return getTV(SERVICE_TYPES);
    },
    agentsTV() {
      return getTV(this.agents, { textField: "name", valueField: "id" });
    },
    employersTV() {
      return getTV(this.employers, { textField: "name", valueField: "id" });
    },
    projectOwnersTV() {
      return getTV(PROJECT_OWNER, { isDeselect: false });
    },
  },
  methods: {
    onCancelled() {
      this.clearForm();
      this.$emit("cancelled");
    },
    onNewItemAdded(addedData) {
      this.$emit("added", addedData);
      this.onCancelled();
    },
    validate() {
      if (this.$refs.addProjectForm.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.addProjectForm.reset();
    },
    resetValidation() {
      this.$refs.addProjectForm.resetValidation();
    },
    clearForm() {
      this.newItem = {
        contract_date: new Date().toISOString().substr(0, 10),
        agent_id: "", // old
        applied_country: "",
        profession: "",
        name: "", //old
        father_name: "",
        mother_name: "",
        present_district: "",
        present_upazila: "",
        present_union: "",
        present_village: "",
        permanent_district: "",
        permanent_upazila: "",
        permanent_union: "",
        permanent_village: "",
        passport_number: "", //old
        passport_issue_date: "",
        passport_exp_date: "",
        dob: "", //old
        age: "",
        nid_number: "", //old
        birth_cert_number: "",
        nationality: "",
        gender: "", //old
        religion: "",
        marital_status: "",
        height: "",
        weight: "",
        language_proficiency: [],
        educational_qualification: "",
        working_experience: "",
        working_experience_type: "",
        mobile: "", //old
        family_mobile_number: "",
        notes: "",
      };
    },

    onChangeDepartmentSelect(selecteddepartmentID) {
      // const department = this.departments.find(
      //   (item) => item.id == selecteddepartmentID
      // );
      // this.newItem.department_title = department.title;
    },
    newItemDo() {
      if (this.$refs.addProjectForm.validate()) {
        this.actionButtonClicked = true;
        this.post(
          "/project",
          removeEmptyProps({...this.newItem, language_proficiency: (this.newItem.language_proficiency || []).join()}, [
            "contract_date",
            "dob",
            "visa_issue_date",
            "flight_date",
            "medical_date",
            "mofa_date",
            "training_start_date",
            "training_end_date"
          ])
        ).then((res) => {
          if (res.data.success) {
            this.onNewItemAdded(res.data.data);
          }
          this.snackbarShow(res.data);
          this.actionButtonClicked = false;
        });
      }
    },
    districtTV: districtTV,
    upazilaTV: upazilaTV,
    unionTV: unionTV,
    getTV: getTV,
  },
  mounted() {},
  created() {
    this.GENDERS = GENDERS;
  },
};
</script>
